"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const oneEntry_1 = require("../base/oneEntry");
/**
 * Controllers for working with users - admins
 */
class AdminsApi extends oneEntry_1.default {
    constructor(url, token) {
        super(url, token);
        this._url += '/api/content/admins';
    }
    /**
     * Get all user objects - admins.
     *
     * @param {string} [langCode] - Language code. Default "en_US"
     * @param {number} [offset] - Parameter for pagination. Default 0
     * @param {number} [limit] - Parameter for pagination. Default 30
     *
     * @returns Returns all AdminEntity user objects
     */
    async getAdminsInfo(langCode = 'en_US', offset = 0, limit = 30) {
        const result = await this._fetchGet(`?langCode=${langCode}&offset=${offset}&limit=${limit}`);
        return result;
    }
}
exports.default = AdminsApi;
